import React from 'react';

export default {
  crossOut: {
    viewBox: '0 0 28 26',
    width: 28,
    height: 26,
    body: () => (
      <>
        <path
          d="M23 0H5a5 5 0 0 0-5 5v16a5 5 0 0 0 5 5h18a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5z"
          fill="var(--current-background-color)"
        />
        <path
          d="M23 0H5C2.24 0 0 2.24 0 5v16c0 2.76 2.24 5 5 5h18c2.76 0 5-2.24 5-5V5c0-2.76-2.24-5-5-5zm4 21c0 2.21-1.79 4-4 4H5c-2.21 0-4-1.79-4-4V5c0-2.21 1.79-4 4-4h18c2.21 0 4 1.79 4 4v16z"
          fill="#1E1E1E"
        />
        <path
          d="M18.45 8.81s-.05.02-.07.04c-.25.16-.47.35-.66.57l-.64.53c-.13-.35-.32-.66-.63-.88-.54-.4-1.32-.59-2.36-.59H11.1v5.85L8.91 8.48H7.28L4.1 17.01h1.87l.59-1.76h3.08l.22.64-5.59 4.6.63.77 5.3-4.36 2.66-2.17v-.02l1.71-1.41h.02l5.99-4.92h-.02l3.73-3.07-.63-.77-5.2 4.28-.01-.01zM7.04 13.82l1.06-3.19 1.07 3.19H7.04zm5.82-.41v-.13h.16l-.16.13zm2.57-2.12-.84.69c-.13.03-.27.05-.43.06h-1.3V9.89h1.23c.48 0 .84.08 1.06.25.22.17.34.45.34.84 0 .12-.03.21-.06.31zM21.44 15.313c-.27.25-.67.37-1.22.37-.6 0-1.04-.21-1.32-.64-.28-.43-.42-1.1-.42-2.02v-.64c0-.41.04-.76.11-1.07l-1.89 1.55v.08s-.04-.02-.06-.04l-1.12.92c.1.18.16.38.16.65 0 .35-.12.62-.35.82-.23.2-.56.3-.97.3h-.98l-1.72 1.41h2.75c.97 0 1.71-.22 2.24-.64.29-.23.49-.53.62-.88.11.19.23.38.37.54.63.74 1.49 1.11 2.58 1.11 1 0 1.81-.26 2.42-.79.61-.53.95-1.25 1.02-2.17H21.9c-.04.52-.19.9-.46 1.15v-.01zM21.82 8.648l-1.41 1.16c.45.02.82.13 1.05.35.26.25.42.65.46 1.2h1.76c-.09-.95-.44-1.69-1.04-2.22-.24-.21-.51-.37-.81-.49h-.01z"
          fill="var(--current-text-color)"
        />
      </>
    ),
  },
  mcqRadioCrossout: {
    viewBox: '0 0 26 20',
    width: 26,
    height: 20,
    body: () => (
      <>
        <path
          d="M13 19.25C7.9 19.25 3.75 15.1 3.75 10C3.75 4.9 7.9 0.75 13 0.75C18.1 0.75 22.25 4.9 22.25 10C22.25 15.1 18.1 19.25 13 19.25ZM13 1.75C8.45 1.75 4.75 5.45 4.75 10C4.75 14.55 8.45 18.25 13 18.25C17.55 18.25 21.25 14.55 21.25 10C21.25 5.45 17.55 1.75 13 1.75Z"
          fill="#1E1E1E"
        />
        <path
          d="M0.700783 10.4297L25.8008 10.4297V9.42969L0.700783 9.42969V10.4297Z"
          fill="#1E1E1E"
        />
      </>
    ),
  },
  mcqCheckoutCrossout: {
    viewBox: '0 0 28 26',
    width: 28,
    height: 26,
    body: () => (
      <>
        <g clipPath="url(#5wmkxj2kaa)">
          <path
            d="M23 0H5a5 5 0 0 0-5 5v16a5 5 0 0 0 5 5h18a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5z"
            fill="#fff"
          />
          <path
            d="M14 21.75a8.75 8.75 0 1 0 0-17.5 8.75 8.75 0 0 0 0 17.5z"
            fill="#fff"
          />
          <g clipPath="url(#kqskyt1hsb)">
            <rect
              x="4.5"
              y="3.5"
              width="19"
              height="19"
              rx="1.5"
              fill="#fff"
              stroke="#1E1E1E"
            />
          </g>
          <path d="M0 14h28v-1H0v1z" fill="#1E1E1E" />
        </g>
        <defs>
          <clipPath id="5wmkxj2kaa">
            <path fill="#fff" d="M0 0h28v26H0z" />
          </clipPath>
          <clipPath id="kqskyt1hsb">
            <path fill="#fff" transform="translate(4 3)" d="M0 0h20v20H0z" />
          </clipPath>
        </defs>
      </>
    ),
  },
  timer_icon: {
    width: '16',
    height: '17',
    viewBox: '0 0 16 17',
    body: () => (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5 0h-7v1.75h2.633v1.303C3.68 3.482 1 6.434 1 10c0 3.86 3.14 7 7 7s7-3.14 7-7a6.973 6.973 0 0 0-1.825-4.708l1.43-1.43-1.238-1.237-1.526 1.526a6.956 6.956 0 0 0-2.958-1.096V1.75H11.5V0zM2.75 10A5.255 5.255 0 0 0 8 15.25 5.255 5.255 0 0 0 13.25 10 5.255 5.255 0 0 0 8 4.75 5.255 5.255 0 0 0 2.75 10zm4.375.875V6.5h1.75v2.625H11.5v1.75H7.125z"
          fill="#888"
        />
      </>
    ),
  },
  pause_screen_quiz_title: {
    width: '32',
    height: '32',
    viewBox: '0 0 32 32',
    body: () => (
      <>
        <circle cx="16" cy="16" r="15.5" stroke="#505050" />
        <path
          d="M23.47 11.38H13.12c-.29 0-.53-.24-.53-.53 0-.29.24-.53.53-.53h10.35c.29 0 .53.24.53.53 0 .29-.24.53-.53.53zM23.47 16.53H13.12c-.29 0-.53-.24-.53-.53 0-.29.24-.53.53-.53h10.35c.29 0 .53.24.53.53 0 .29-.24.53-.53.53zM23.47 21.68H13.12c-.29 0-.53-.24-.53-.53 0-.29.24-.53.53-.53h10.35c.29 0 .53.24.53.53 0 .29-.24.53-.53.53zM9.29 12.14a1.29 1.29 0 1 0 0-2.58 1.29 1.29 0 0 0 0 2.58zM9.29 17.29a1.29 1.29 0 1 0 0-2.58 1.29 1.29 0 0 0 0 2.58zM9.29 22.44a1.29 1.29 0 1 0 0-2.58 1.29 1.29 0 0 0 0 2.58z"
          fill="#fff"
        />
      </>
    ),
  },
};
